import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiError, setAdminToken } from "@/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, ShieldCheck } from "lucide-react";
import { ADMIN } from "@/constants/testIds";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setAdminToken(data.token);
      navigate("/admin");
    } catch (err) {
      setError(apiError(err, "Invalid email or password"));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-slate-900 text-white p-12">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-md bg-white grid place-items-center text-slate-900 font-bold font-head">M</div>
          <span className="font-head font-bold text-lg">MSI Scale</span>
        </div>
        <div>
          <p className="eyebrow text-blue-300">Administration</p>
          <h1 className="text-4xl font-bold tracking-tight mt-3 max-w-sm">Manage Test IDs, domains and reports</h1>
          <p className="text-slate-400 mt-4 max-w-sm">Generate MSIS & MSOS test credentials, control domain scope, and review completed assessments.</p>
        </div>
        <p className="text-slate-500 text-sm">© {new Date().getFullYear()} MSI Scale</p>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm">
          <div className="w-12 h-12 rounded-full bg-blue-50 grid place-items-center mb-5"><ShieldCheck className="w-6 h-6 text-blue-700" /></div>
          <h2 className="text-2xl font-bold tracking-tight">Admin sign in</h2>
          <p className="text-slate-500 mt-2">Enter your administrator credentials.</p>
          <div className="mt-8 space-y-4">
            <div>
              <Label className="mb-1.5 block">Email</Label>
              <Input data-testid={ADMIN.emailInput} type="email" value={email}
                onChange={(e) => setEmail(e.target.value)} className="h-11" placeholder="admin@example.com" />
            </div>
            <div>
              <Label className="mb-1.5 block">Password</Label>
              <Input data-testid={ADMIN.passwordInput} type="password" value={password}
                onChange={(e) => setPassword(e.target.value)} className="h-11" placeholder="••••••••" />
            </div>
            {error && <p data-testid={ADMIN.loginError} className="text-sm text-red-600">{error}</p>}
            <Button data-testid={ADMIN.loginButton} type="submit" disabled={loading}
              className="w-full h-11 rounded-full bg-blue-700 hover:bg-blue-800 text-white">
              {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null} Sign in
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
